import type { JSX, ReactNode } from 'react'

import { clsx } from 'clsx'

import { Card, Text, UnstyledButton } from '@buffer-mono/popcorn'

import { getDraftPreviewLabel } from '~publish/components/ContentItemCard'
import { DraftBadge } from '~publish/components/PostStatusBadge'

import { ContentItemPopover } from '../ContentItemPopover'

import styles from './ContentItemCalendarItem.module.css'

export function ContentItemCalendarItemView({
  text,
  label,
  networks,
  media,
  condensed = false,
  preview,
  isOpen,
  onOpenChange,
}: {
  text: string
  label?: string
  networks?: ReactNode
  media?: ReactNode
  condensed?: boolean
  preview: ReactNode
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}): JSX.Element {
  const body = (
    <>
      <DraftBadge size="small" />
      {networks}
      <Text
        size="sm"
        className={clsx(styles.text, condensed && styles.textCondensed)}
      >
        {text}
      </Text>
    </>
  )

  return (
    <ContentItemPopover
      preview={preview}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <UnstyledButton
        aria-label={label ?? getDraftPreviewLabel(text)}
        className={styles.trigger}
      >
        <Card className={clsx(styles.card, media && styles.cardWithMedia)}>
          {media ? (
            <>
              <div className={styles.content}>{body}</div>
              <div
                className={clsx(
                  styles.media,
                  condensed && styles.mediaCondensed,
                )}
              >
                {media}
              </div>
            </>
          ) : (
            body
          )}
        </Card>
      </UnstyledButton>
    </ContentItemPopover>
  )
}
